import { Component, OnInit } from '@angular/core';
import { PatientService } from '../../patient.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class PatientComponent implements OnInit {

  patients = []
   
  constructor(
    protected patientService: PatientService
  ) {
  }

  ngOnInit() {
    this.patientService.getPatients()
    .subscribe(
      (data) => { // Success
      	this.patients = data as string [];
        console.log(data);
      },
      (error) => {
        console.error(error);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/list.component.ts